import LayoutConstants from '@/constansts/layoutConstants';

const normalizeToAppPath = (path) => {
  if (!path || typeof path !== 'string') return '';
  let p = path;
  if (!p.startsWith('/')) p = `/${p}`;
  if (!p.startsWith('/app/')) p = `/app${p}`;
  return p;
};

const pathMatchesMatcher = (normalizedPath, matcher) => {
  if (matcher.type === 'prefix') {
    return normalizedPath.startsWith(matcher.path);
  }
  if (matcher.type === 'exactOrQuery') {
    return normalizedPath === matcher.path || normalizedPath.startsWith(`${matcher.path}?`);
  }
  return false;
};

let cachedSurfaceMatchers;

export const buildPlatformDesktopAccountRows = ({
  myAccountMenuWideFF,
  newProfilePageFF,
  hasRolesAndPermissions,
  hasGettingStartedDeny,
}) => {
  const myAccountRoute = myAccountMenuWideFF ? 'app.setting_menu' : 'app.settings_page';
  const profileRoute = newProfilePageFF ? 'staffProfile' : 'app.business_info_settings';
  const profileRouteType = newProfilePageFF
    ? LayoutConstants.ROUTING_TYPES.pov
    : LayoutConstants.ROUTING_TYPES.angular;

  const rows = [
    {
      event: 'my-account',
      labelKey: 'common.navigation.account_platform_navigation',
      icon: 'icon-User-vneck',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_settings',
      nav: {
        routingType: LayoutConstants.ROUTING_TYPES.angular,
        route: myAccountRoute,
        routeData: { page: 'my_account' },
      },
      platformPageMatchers: [{
        type: 'exactOrQuery',
        path: myAccountMenuWideFF ? '/app/setting/my_account' : '/app/settings/my_account',
      }],
    },
    {
      event: 'business-info',
      labelKey: 'common.navigation.profile',
      icon: 'icon-Suitcase',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_settings',
      nav: {
        routingType: profileRouteType,
        route: profileRoute,
      },
      platformPageMatchers: [newProfilePageFF
        ? { type: 'prefix', path: '/app/settings/staff_profile' }
        : { type: 'exactOrQuery', path: '/app/settings/business' }],
    },
    {
      event: 'staff',
      labelKey: 'common.navigation.staff',
      icon: 'icon-Staff',
      roles: ['admin'],
      permission: 'can_access_staff_management',
      nav: {
        routingType: LayoutConstants.ROUTING_TYPES.angular,
        route: 'app.settings_page',
        routeData: { page: 'staff' },
      },
      platformPageMatchers: [{ type: 'exactOrQuery', path: '/app/settings/staff' }],
    },
  ];

  if (hasRolesAndPermissions) {
    rows.push({
      event: 'role_permissions',
      labelKey: 'common.navigation.role_permissions',
      icon: 'icon-Lock2',
      roles: ['admin', 'manager', 'marketing'],
      permission: 'can_access_staff_management',
      nav: {
        routingType: LayoutConstants.ROUTING_TYPES.pov,
        route: 'RolesListPage',
      },
      platformPageMatchers: [{ type: 'prefix', path: '/app/settings/roles_and_permissions' }],
    });
  }

  if (!hasGettingStartedDeny) {
    rows.push({
      event: 'getting-started',
      labelKey: 'onboarding.new_onboarding.quick_btn_title',
      icon: 'icon-Rocket_new',
      roles: ['admin'],
      permission: 'can_access_admin_account',
      nav: { action: 'openChecklist' },
      platformPageMatchers: [],
    });
  }

  return rows;
};

export const buildPlatformDesktopAccountMenuItemsFromRows = (rows, t) => rows.map((row) => {
  const { nav, labelKey, platformPageMatchers, ...rest } = row;
  return {
    label: t(labelKey),
    ...rest,
    ...nav,
  };
});

export const getPlatformAccountSurfaceMatchersUnion = () => {
  if (cachedSurfaceMatchers) return cachedSurfaceMatchers;

  const seen = new Set();
  const matchers = [];

  [false, true].forEach((myAccountMenuWideFF) => {
    [false, true].forEach((newProfilePageFF) => {
      const rows = buildPlatformDesktopAccountRows({
        myAccountMenuWideFF,
        newProfilePageFF,
        hasRolesAndPermissions: true,
        hasGettingStartedDeny: true,
      });
      rows.forEach(({ platformPageMatchers }) => {
        platformPageMatchers.forEach((m) => {
          const key = `${m.type}:${m.path}`;
          if (!seen.has(key)) {
            seen.add(key);
            matchers.push(m);
          }
        });
      });
    });
  });

  cachedSurfaceMatchers = matchers;
  return cachedSurfaceMatchers;
};

export const isPlatformAccountSurfacePath = (path) => {
  const p = normalizeToAppPath(path);
  if (!p) return false;
  return getPlatformAccountSurfaceMatchersUnion().some((m) => pathMatchesMatcher(p, m));
};
